import React from "react";
import {
  WoodBox,
  WoodCardShell,
  WoodRowShell,
  WoodTableHeader,
  WoodTableShell,
} from "./styles";

function Box({ width, height }) {
  return <WoodBox $width={width} $height={height} aria-hidden="true" />;
}

function Row({ columns = 4, repeat = 1 }) {
  return Array.from({ length: repeat }).map((_, rowIndex) => (
    <WoodRowShell key={rowIndex} $columns={columns} aria-hidden="true">
      {Array.from({ length: columns }).map((__, columnIndex) => (
        <WoodBox
          key={columnIndex}
          $width="100%"
          $height="14px"
        />
      ))}
    </WoodRowShell>
  ));
}

function Card({ height }) {
  return <WoodCardShell $height={height} aria-hidden="true" />;
}

function Table({ rows = 5, columns = 4 }) {
  return (
    <WoodTableShell aria-hidden="true" role="presentation">
      <WoodTableHeader $columns={columns}>
        {Array.from({ length: columns }).map((_, i) => (
          <WoodBox key={i} $width="60%" $height="10px" />
        ))}
      </WoodTableHeader>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <WoodRowShell key={rowIndex} $columns={columns}>
          {Array.from({ length: columns }).map((__, columnIndex) => (
            <WoodBox key={columnIndex} $width="100%" $height="14px" />
          ))}
        </WoodRowShell>
      ))}
    </WoodTableShell>
  );
}

const WoodSkeleton = { Box, Row, Card, Table };

export default WoodSkeleton;
